import {
  createContext,
  useContext,
  useEffect,
  useSyncExternalStore,
  type ReactNode,
} from "react";
import { getLocale, subscribeLocale, tx, type Locale } from "./i18n";
const LanguageContext = createContext<Locale>("en");
export function I18nProvider({ children }: { children: ReactNode }) {
  const locale = useSyncExternalStore(
    subscribeLocale,
    getLocale,
    () => "en" as const,
  );
  useEffect(() => {
    document.documentElement.lang = locale;
    document.title = tx("Luuta — Analytics", {}, locale);
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute(
        "content",
        tx(
          "Luuta Analytics — operational clarity, from readiness to the records behind every result.",
          {},
          locale,
        ),
      );
  }, [locale]);
  return (
    <LanguageContext.Provider value={locale}>
      {children}
    </LanguageContext.Provider>
  );
}
export function useLocale() {
  return useContext(LanguageContext);
}
